import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import ContentHeader from './components/ContentHeader.vue';
import Content from './components/ContentVue.vue';

// Importar Axios configurado
import axios from './plugins/axios';

// Importar DataTables
import 'datatables.net';
import 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';

// Importar CSS de DataTables
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';

// Importar Bootstrap y Font Awesome
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';

import Swal from 'sweetalert2';

import 'jquery';
import draggable from 'vuedraggable';
import moment from 'moment';

import "@/assets/css/loadingAlert.css";

import '@/assets/css/elementStyle.css';

import 'bootstrap-icons/font/bootstrap-icons.css';
import { initKeycloak, getRoles } from './services/api/keycloak';



const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});
window.Swal = Swal;
window.Toast = Toast;

const app = createApp(App);

// Configurar Axios globalmente
app.config.globalProperties.$axios = axios;

// Configurar moment globalmente
app.config.globalProperties.$moment = moment;


console.log('Inicializando Keycloak...');

// 2. Llamamos a initKeycloak() y manejamos el resultado con .then()
initKeycloak()
  .then(authenticated => {
    const roles = getRoles();
    console.log('Roles:', roles);
    // Opcional: Puedes usar 'authenticated' para saber si el usuario hizo login.
    app.component('content-header', ContentHeader)
    app.component('vue-draggable', draggable)
      .component('content', Content)
      .use(store)
      // 3. Solo si Keycloak se inicializa correctamente:
      .use(router)
      .mount('#app');
    console.log(`Aplicación Vue montada. Autenticado: ${authenticated}`);

  })
  .catch(error => {
    // 4. Manejo de error si Keycloak falla (ej. servidor Keycloak caído)
    console.error('La aplicación no pudo inicializarse. Keycloak falló:', error);
    // Aquí podrías mostrar un mensaje simple en el DOM, ya que la app no se monta.
  });

/*

app.component('content-header', ContentHeader)
/* eslint-disable vue/multi-word-component-names */
/*
app.component('draggable', draggable)
  .component('content', Content)
  .use(store)
  .use(router)
  .mount('#app');
*/
